var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.95801H3C2.65833 6.95801 2.375 6.67467 2.375 6.33301C2.375 5.99134 2.65833 5.70801 3 5.70801H18C18.3417 5.70801 18.625 5.99134 18.625 6.33301C18.625 6.67467 18.3417 6.95801 18 6.95801Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.125H5.5C5.15833 11.125 4.875 10.8417 4.875 10.5C4.875 10.1583 5.15833 9.875 5.5 9.875H15.5C15.8417 9.875 16.125 10.1583 16.125 10.5C16.125 10.8417 15.8417 11.125 15.5 11.125Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1668 15.292H8.8335C8.49183 15.292 8.2085 15.0087 8.2085 14.667C8.2085 14.3253 8.49183 14.042 8.8335 14.042H12.1668C12.5085 14.042 12.7918 14.3253 12.7918 14.667C12.7918 15.0087 12.5085 15.292 12.1668 15.292Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8d744a6edbda164157024f478601cbea.svg";
export { ForwardRef as ReactComponent };